import script from "./StatusBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatusBar.vue?vue&type=script&lang=ts&setup=true"

import "./StatusBar.vue?vue&type=style&index=0&id=d26955c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d26955c2"]])

export default __exports__